/* Progressive enhancement: Shopify owns products, cart state and checkout. */
(() => {
  'use strict';
  const brandHeader = document.querySelector('[data-brand-header]');
  if (brandHeader) {
    const updateHeader = () => brandHeader.classList.toggle('is-scrolled', window.scrollY > 40);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }
  const root = window.Shopify?.routes?.root || '/';
  let lastCartTrigger;
  let cartBusy = false;
  const getDrawer = () => document.getElementById('CartDrawer');
  const announce = message => { const status = document.getElementById('StoreStatus'); if (status) status.textContent = message; };
  function openCart(trigger) { const drawer = getDrawer(); if (!drawer?.showModal) return false; lastCartTrigger = trigger; if (!drawer.open) drawer.showModal(); return true; }
  function closeCart() { getDrawer()?.close(); lastCartTrigger?.focus(); }
  getDrawer()?.addEventListener('close', () => lastCartTrigger?.focus());
  function setBusy(busy) {
    cartBusy = busy;
    document.querySelectorAll('[data-cart-change]').forEach(button => { button.disabled = busy; });
    getDrawer()?.setAttribute('aria-busy', String(busy));
  }
  function renderCart(html, trigger, focusKey) {
    if (!html) { window.location.assign(root + 'cart'); return; }
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.getElementById('CartDrawer');
    const drawer = getDrawer();
    if (!fresh || !drawer) { window.location.assign(root + 'cart'); return; }
    drawer.innerHTML = fresh.innerHTML;
    const count = parsed.querySelector('[data-drawer-count]')?.dataset.drawerCount;
    if (count !== undefined) document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
    openCart(trigger || lastCartTrigger);
    const focusLine = focusKey && [...drawer.querySelectorAll('[data-cart-key]')].find(line => line.dataset.cartKey === focusKey);
    (focusLine?.querySelector('[data-cart-change]') || drawer.querySelector('[data-close-cart]'))?.focus();
  }
  async function updateCart(endpoint, body, trigger, focusKey) {
    setBusy(true);
    let response;
    try {
      response = await fetch(root + endpoint, { method: 'POST', body, headers: { Accept: 'application/json' } });
    } catch {
      throw new Error('We couldn’t confirm the update. Check your bag before trying again.');
    }
    let result;
    try { result = await response.json(); }
    catch { throw new Error('We couldn’t confirm the update. Check your bag before trying again.'); }
    if (!response.ok) throw new Error(result.description || result.message || 'Your bag could not be updated. Please try again.');
    renderCart(result.sections?.['cart-drawer'], trigger, focusKey);
    announce('Your shopping bag has been updated.');
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-open-cart]');
    if (open && openCart(open)) event.preventDefault();
    if (event.target.closest('[data-close-cart]')) closeCart();
    if (event.target === getDrawer()) { const rect = event.target.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right) closeCart(); }
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-change]');
    if (!button || cartBusy) return;
    const key = button.closest('[data-cart-key]').dataset.cartKey;
    const body = new FormData();
    body.set('id', key);
    body.set('quantity', button.dataset.cartChange);
    body.set('sections', 'cart-drawer');
    body.set('sections_url', root + 'cart');
    const error = getDrawer()?.querySelector('[data-cart-error]');
    if (error) error.textContent = '';
    try { await updateCart('cart/change.js', body, null, key); }
    catch (failure) { const target = getDrawer()?.querySelector('[data-cart-error]'); if (target) target.textContent = failure.message; }
    finally { setBusy(false); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !getDrawer()?.showModal) return;
    event.preventDefault();
    if (cartBusy || !form.reportValidity()) return;
    const button = form.querySelector('[data-add-to-cart]');
    if (button.disabled) return;
    const error = form.querySelector('[data-product-error]');
    const label = button.querySelector('[data-add-label]');
    error.textContent = '';
    const body = new FormData(form);
    body.set('sections', 'cart-drawer');
    body.set('sections_url', root + 'cart');
    button.disabled = true;
    label.textContent = 'Adding…';
    try { await updateCart('cart/add.js', body, button); }
    catch (failure) { error.textContent = failure.message; }
    finally {
      setBusy(false);
      const available = form.querySelector('[data-variant-select]').selectedOptions[0]?.dataset.available === 'true';
      button.disabled = !available || button.hasAttribute('data-requires-plan');
      label.textContent = available ? 'Add to bag' : 'Sold out';
    }
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-select]');
    if (select) {
      const option = select.selectedOptions[0];
      const section = select.closest('[data-product-section]');
      const price = section.querySelector('[data-product-price]');
      price.textContent = option.dataset.price;
      if (option.dataset.compare) { const compare = document.createElement('s'); compare.textContent = option.dataset.compare; price.append(' ', compare); }
      const button = section.querySelector('[data-add-to-cart]');
      const available = option.dataset.available === 'true';
      button.disabled = cartBusy || !available || button.hasAttribute('data-requires-plan');
      button.querySelector('[data-add-label]').textContent = available ? 'Add to bag' : 'Sold out';
      section.querySelector('[data-product-error]').textContent = '';
      const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
      if (option.dataset.media) document.getElementById(option.dataset.media)?.scrollIntoView({ block: 'nearest', behavior: 'instant' });
    }
    if (event.target.matches('[data-sort-select]')) event.target.form.requestSubmit();
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('details[open]').forEach(detail => { detail.open = false; detail.querySelector('summary')?.focus(); }); });
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let cleanMotion = () => {};
  function setupMotion() {
    cleanMotion();
    if (reducedMotion.matches || document.body.dataset.motion === 'false') return;
    const hero = document.querySelector('[data-parallax]');
    let frame = 0;
    const updateScroll = () => {
      frame = 0;
      if (hero) { const rect = hero.getBoundingClientRect(); if (rect.bottom > 0 && rect.top < innerHeight) hero.style.setProperty('--scroll', Math.min(1, Math.max(0, -rect.top / rect.height))); }
    };
    const scheduleScroll = () => { if (!frame) frame = requestAnimationFrame(updateScroll); };
    const move = event => { if (event.pointerType !== 'mouse') return; const rect = hero.getBoundingClientRect(); hero.style.setProperty('--px', (event.clientX - rect.left) / rect.width - .5); hero.style.setProperty('--py', (event.clientY - rect.top) / rect.height - .5); };
    const reset = () => { hero?.style.setProperty('--px', 0); hero?.style.setProperty('--py', 0); };
    hero?.addEventListener('pointermove', move);
    hero?.addEventListener('pointerleave', reset);
    window.addEventListener('scroll', scheduleScroll, { passive: true });
    window.addEventListener('resize', scheduleScroll, { passive: true });
    scheduleScroll();
    cleanMotion = () => {
      hero?.removeEventListener('pointermove', move); hero?.removeEventListener('pointerleave', reset);
      window.removeEventListener('scroll', scheduleScroll); window.removeEventListener('resize', scheduleScroll);
      cancelAnimationFrame(frame); reset(); hero?.style.setProperty('--scroll', 0);
    };
  }
  setupMotion();
  reducedMotion.addEventListener('change', setupMotion);
  document.addEventListener('shopify:section:load', setupMotion);
  document.addEventListener('shopify:section:unload', () => { cleanMotion(); requestAnimationFrame(setupMotion); });
  const scenes = new Map();
  function discoverCreations(scope = document) {
    if (!window.IntersectionObserver) return;
    scope.querySelectorAll('[data-creation]').forEach(section => {
      if (scenes.has(section)) return;
      const state = { disposed: false, cleanup: null };
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        import(section.dataset.controller).then(module => module.mountCreation(section)).then(cleanup => {
          if (state.disposed) cleanup(); else state.cleanup = cleanup;
        }).catch(() => {});
      }, { rootMargin: '1000px' });
      state.dispose = () => { state.disposed = true; observer.disconnect(); state.cleanup?.(); };
      scenes.set(section, state); observer.observe(section);
    });
  }
  discoverCreations();
  document.addEventListener('shopify:section:load', event => discoverCreations(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, state] of scenes) if (event.target.contains(section)) { state.dispose(); scenes.delete(section); }
  });
})();
